import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

import * as styles from './styles';
import type { StyleProps } from './styles';

type TypographyTypeMap = BaseTypeMap<'p', StyleProps>;

export type TypographyProps = ComponentProps<TypographyTypeMap>;

export const Typography: Component<TypographyTypeMap> = forwardRef(
  function Typography(
    {
      children,
      className,
      as = 'p',
      intent,
      size,
      weight = 'default' as StyleProps['weight'],
      color,
      gutter,
      ...rest
    },
    ref
  ) {
    return (
      <Box
        className={cx(
          styles.typography({ intent, size, weight, color, gutter }),
          className
        )}
        ref={ref}
        as={as}
        {...rest}
      >
        {children}
      </Box>
    );
  }
);
